import { FC } from 'react'

import { getMarketCode, isMarketOff } from '../../lib/marketStatus'
import { Pill } from '../pill/Pill'

interface IBusinessPriorityMarketProps {
  market: string
}

export const BusinessPriorityMarket: FC<IBusinessPriorityMarketProps> = ({ market }) => {
  const isOff = isMarketOff(market)

  return (
    <Pill color={isOff ? 'gray' : 'blue'} strikethrough={isOff}>
      {getMarketCode(market)}
    </Pill>
  )
}
